import Button from "components/base/Button";
import { Input, Text } from "components/base/Form";
import useSendEmail from "hooks/useSendEmail";
import { useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const EMAIL_INPUT_ALLOWED_REGEX = /[^a-zA-Z0-9@._,+\-\s]/g;

const SendProductEmailView = ({ product, hide }) => {
  const [title, setTitle] = useState(
    `WIS / Product [${product.number}] ${product.name}`,
  );
  const [to, setTo] = useState("sharon@waboba.com");
  const [message, setMessage] = useState(
    "Product: " +
      product.name +
      "\n" +
      "Item Number: " +
      product.number +
      "\n\n",
  );
  const [send, sendRes] = useSendEmail();

  function toChangeHandler(e) {
    const nextValue = e.target.value.replace(EMAIL_INPUT_ALLOWED_REGEX, "");
    setTo(nextValue);
  }

  const toEmails = to
    .split(",")
    .map((email) => email.trim())
    .filter(Boolean);
  const isTitleValid = Boolean(title.trim());
  const isMessageValid = Boolean(message.trim());
  const hasAtLeastOneEmail = toEmails.length > 0;
  const isValidEmails = toEmails.every((email) => EMAIL_REGEX.test(email));
  const isToValid = hasAtLeastOneEmail && isValidEmails;
  const canSend = isTitleValid && isMessageValid && isToValid;

  function sendHandler() {
    if (!canSend) return;

    // Append current link to the end of the message
    const currentLink = window.location.href;
    const messageWithLink = `${message}\n\nView Product: ${currentLink}`;

    send({
      variables: {
        to: toEmails,
        subject: title,
        message: messageWithLink,
      },
      onCompleted() {
        hide();
      },
    });
  }

  return (
    <div>
      <div className="space-y-3">
        <div className="flex items-center space-x-3">
          <label className="w-12">Title:</label>
          <Input
            className="flex-1"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            validated={isTitleValid}
          />
        </div>

        <div className="flex items-baseline space-x-3">
          <label className="w-12">To:</label>
          <div className="flex-1">
            <Input
              className="w-full"
              value={to}
              onChange={toChangeHandler}
              validated={isToValid}
            />
            <div className="text-xs opacity-70 m-1">
              Separate multiple emails with commas
            </div>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <Text
          className={
            isMessageValid ? "" : "!border-red-500 dark:!border-red-800"
          }
          value={message}
          placeholder="Please input message..."
          onChange={(e) => setMessage(e.target.value)}
          rows={10}
        />
        <div className="text-xs opacity-70 m-1">
          Add additional message you want to include in the email. The current
          product link will be appended to the end of the email.
        </div>
      </div>

      <div className="mt-4 text-sm">
        <Button
          primary
          send
          loading={sendRes.loading}
          onClick={sendHandler}
          disabled={!canSend}
        >
          Send
        </Button>
      </div>
    </div>
  );
};

export default SendProductEmailView;
